import { custodiansApi } from 'apiConnector/custodians';
import { tabRemoved } from 'epic/workspace/common/tabs/tabsEpics/tabRemoved';
import type { Custodian } from 'models/custodian';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, mergeMap, takeUntil, timeoutWith } from 'rxjs/operators';
import { addonCustodiansReloaded, addonCustodiansReloadFailed } from 'state/addonForm/addonForm.action';
import * as actionTypes from 'state/addonForm/addonForm.actionTypes';
import type { EpicWithThunk } from 'state/state.common';

export interface FetchCustodiansApi {
  fetchCustodians(clientId: string): Observable<Custodian[]>;
}
export function fetchAddonCustodiansEpic(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType(actionTypes.ADDON_CLIENT_CHANGED),
      mergeMap(({ tabId, selectedOnBehalfClient }) => {
        if (selectedOnBehalfClient === null) {
          return of(addonCustodiansReloaded(tabId, []));
        }
        const tabRemoved$ = tabRemoved(actions$, tabId, state$);
        return custodiansApi(httpClient)
          .fetchCustodians(selectedOnBehalfClient!.id)
          .pipe(
            takeUntil(tabRemoved$),
            mergeMap(custodians => of(addonCustodiansReloaded(tabId, custodians))),
            catchError(() => of(addonCustodiansReloadFailed(tabId, 'could not retrieve custodians'))),
            timeoutWith(timeoutInMillis, of(addonCustodiansReloadFailed(tabId, 'TIMEOUT')), appScheduler),
          );
      }),
    );
}
